<template>
    <ImpedimentContainer
        title="MR-Discapacidad Intelectual"
    >
        <p><b>El estudiante presenta:</b></p>
        <TreeOptions
            v-model="optionsTree"
            :is-disabled="isDisabled"
            :show-error="showErrors && !isValid"
        />

        <div class="severity__container">
            <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                name="severity"
                rules="required"
            >
                <CustomDropDown
                    id="severity"
                    v-model="innerModel.severity"
                    label="Severidad:"
                    custom-error-msg="Favor de seleccionar la severidad de la Discapacidad Intelectual. (21045)"
                    :error="errors[0]"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="severityOptions"
                    :disabled="isDisabled"
                />
            </ValidationProvider>
        </div>
    </ImpedimentContainer>
</template>
  
<script>
import TreeOptions from './options/TreeOptions.vue';
import ImpedimentMixin from './common/ImpedimentMixin';
import ImpedimentContainer from './common/ImpedimentContainer';

import { ValidationProvider } from 'vee-validate';
import { CustomDropDown } from '@/components/common';

export default {
    name: 'DisturbioEmocional',
    mixins: [ImpedimentMixin],
    components: {
        TreeOptions,
        ImpedimentContainer,
        ValidationProvider,
        CustomDropDown
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                severity: null
            })
        },
        severityOptions: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        innerModel: null,
        showErrors: false,
    }),
    methods: {
        validate() {
            this.showErrors = true;
            return this.isValid;
        }
    },
    computed: {
        isValid() {
            return this.isValidOptionsSelection;
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.innerModel = newValue;
            }
        },
        innerModel: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
    }
}
</script>

<style scoped>
.severity__container {
    width: 20vw;
}
</style>